// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ArHy","right":"Footer_right__awOyP","buttons":"Footer_buttons__hlcH8"};